import { action } from 'easy-peasy';
import { IActionSetNotifyCount } from '../types';

const setNotifyCount: IActionSetNotifyCount = action((state, id) => {
  state.notifyCount = id;
});

export default setNotifyCount;
